<template>
  <div class="dialog">
    <span class="cls" @click="oth_showBmsTest(false)"></span>
    <div class="paper">
      <div class="header">
        <h2>BMS 브랜드메시지 테스트</h2>
        <span @click="oth_showBmsTest(false)"><i class="ph ph-x"></i></span>
      </div>

      <!-- 스크롤 영역 -->
      <div class="scroll-area">

        <!-- ===== 섹션 1: 말풍선 타입 선택 ===== -->
        <div class="section">
          <div class="section-title">
            <i class="ph ph-chat-circle-dots"></i>
            <span>말풍선 타입</span>
          </div>
          <div class="type-grid">
            <button
              v-for="t in types" :key="t.value"
              :class="['type-card', { active: type === t.value }]"
              @click="type = t.value"
            >
              <i :class="['ph', t.icon]"></i>
              <span>{{ t.label }}</span>
            </button>
          </div>
          <!-- 타입 설명 + 미리보기 -->
          <div class="type-detail">
            <div class="info-box">
              <i class="ph ph-info"></i>
              <div>
                <strong>{{ currentTypeInfo.label }}</strong>
                <p>{{ currentTypeInfo.desc }}</p>
              </div>
            </div>
            <!-- 카카오톡 미니 목업 -->
            <div class="preview-mockup">
              <!-- TEXT -->
              <svg v-if="type === 'TEXT'" viewBox="0 0 160 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="8" width="144" height="104" rx="12" fill="#F7E600" opacity="0.1" stroke="#F7E600" stroke-width="1.5"/>
                <rect x="20" y="22" width="90" height="8" rx="4" fill="#3C1E1E" opacity="0.6"/>
                <rect x="20" y="36" width="120" height="6" rx="3" fill="#3C1E1E" opacity="0.25"/>
                <rect x="20" y="46" width="105" height="6" rx="3" fill="#3C1E1E" opacity="0.25"/>
                <rect x="20" y="56" width="80" height="6" rx="3" fill="#3C1E1E" opacity="0.25"/>
                <rect x="20" y="66" width="115" height="6" rx="3" fill="#3C1E1E" opacity="0.25"/>
                <rect x="20" y="84" width="60" height="20" rx="6" fill="#F7E600" opacity="0.5"/>
                <rect x="30" y="90" width="40" height="7" rx="3" fill="#3C1E1E" opacity="0.4"/>
              </svg>
              <!-- IMAGE -->
              <svg v-else-if="type === 'IMAGE'" viewBox="0 0 160 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="8" width="144" height="124" rx="12" fill="#F7E600" opacity="0.1" stroke="#F7E600" stroke-width="1.5"/>
                <rect x="16" y="16" width="128" height="60" rx="8" fill="#A8D8EA"/>
                <circle cx="42" cy="36" r="8" fill="#FFD93D" opacity="0.8"/>
                <path d="M16 60 L60 42 L90 58 L110 48 L144 65 L144 76 L16 76 Z" fill="#81C784" opacity="0.5"/>
                <rect x="20" y="84" width="90" height="7" rx="3" fill="#3C1E1E" opacity="0.5"/>
                <rect x="20" y="95" width="120" height="5" rx="2.5" fill="#3C1E1E" opacity="0.2"/>
                <rect x="20" y="104" width="80" height="5" rx="2.5" fill="#3C1E1E" opacity="0.2"/>
                <rect x="20" y="118" width="55" height="10" rx="5" fill="#F7E600" opacity="0.5"/>
              </svg>
              <!-- WIDE -->
              <svg v-else-if="type === 'WIDE'" viewBox="0 0 160 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="8" width="144" height="104" rx="12" fill="#F7E600" opacity="0.1" stroke="#F7E600" stroke-width="1.5"/>
                <rect x="16" y="16" width="128" height="48" rx="8" fill="#B2DFDB"/>
                <circle cx="38" cy="34" r="6" fill="#FFD93D" opacity="0.7"/>
                <path d="M16 50 L55 36 L85 48 L120 38 L144 52 L144 64 L16 64 Z" fill="#66BB6A" opacity="0.4"/>
                <rect x="20" y="72" width="100" height="7" rx="3" fill="#3C1E1E" opacity="0.5"/>
                <rect x="20" y="83" width="60" height="5" rx="2.5" fill="#3C1E1E" opacity="0.2"/>
                <rect x="20" y="96" width="55" height="10" rx="5" fill="#F7E600" opacity="0.5"/>
              </svg>
              <!-- COMMERCE -->
              <svg v-else-if="type === 'COMMERCE'" viewBox="0 0 160 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="8" width="144" height="134" rx="12" fill="#F7E600" opacity="0.1" stroke="#F7E600" stroke-width="1.5"/>
                <rect x="16" y="16" width="128" height="55" rx="8" fill="#E1BEE7"/>
                <rect x="50" y="30" width="60" height="28" rx="4" fill="white" opacity="0.6"/>
                <rect x="58" y="36" width="44" height="6" rx="3" fill="#7B1FA2" opacity="0.4"/>
                <rect x="64" y="46" width="32" height="4" rx="2" fill="#7B1FA2" opacity="0.25"/>
                <rect x="20" y="78" width="85" height="7" rx="3" fill="#3C1E1E" opacity="0.5"/>
                <rect x="20" y="90" width="50" height="6" rx="3" fill="#E53935" opacity="0.4"/>
                <text x="20" y="98" font-size="5" fill="#E53935" opacity="0.6">할인</text>
                <rect x="20" y="102" width="70" height="8" rx="3" fill="#3C1E1E" opacity="0.7"/>
                <text x="20" y="109" font-size="7" font-weight="bold" fill="#3C1E1E" opacity="0.5">49,900원</text>
                <rect x="20" y="118" width="120" height="5" rx="2.5" fill="#3C1E1E" opacity="0.15"/>
                <rect x="20" y="126" width="80" height="5" rx="2.5" fill="#3C1E1E" opacity="0.15"/>
              </svg>
              <!-- CAROUSEL_FEED -->
              <svg v-else-if="type === 'CAROUSEL_FEED'" viewBox="0 0 160 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="8" width="88" height="104" rx="10" fill="#F7E600" opacity="0.1" stroke="#F7E600" stroke-width="1.5"/>
                <rect x="10" y="16" width="76" height="40" rx="6" fill="#BBDEFB"/>
                <rect x="14" y="62" width="60" height="6" rx="3" fill="#3C1E1E" opacity="0.5"/>
                <rect x="14" y="72" width="72" height="4" rx="2" fill="#3C1E1E" opacity="0.2"/>
                <rect x="14" y="80" width="50" height="4" rx="2" fill="#3C1E1E" opacity="0.2"/>
                <rect x="14" y="94" width="40" height="10" rx="5" fill="#F7E600" opacity="0.5"/>
                <!-- 두번째 카드 (살짝 보이게) -->
                <rect x="98" y="12" width="58" height="96" rx="10" fill="#F7E600" opacity="0.06" stroke="#F7E600" stroke-width="1" stroke-dasharray="3 2"/>
                <rect x="104" y="20" width="46" height="32" rx="6" fill="#C8E6C9" opacity="0.5"/>
                <rect x="104" y="58" width="36" height="5" rx="2.5" fill="#3C1E1E" opacity="0.2"/>
              </svg>
              <!-- CAROUSEL_COMMERCE -->
              <svg v-else-if="type === 'CAROUSEL_COMMERCE'" viewBox="0 0 160 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="8" width="88" height="124" rx="10" fill="#F7E600" opacity="0.1" stroke="#F7E600" stroke-width="1.5"/>
                <rect x="10" y="16" width="76" height="44" rx="6" fill="#F8BBD0"/>
                <rect x="14" y="66" width="55" height="6" rx="3" fill="#3C1E1E" opacity="0.5"/>
                <rect x="14" y="76" width="40" height="5" rx="2.5" fill="#E53935" opacity="0.3"/>
                <rect x="14" y="85" width="50" height="7" rx="3" fill="#3C1E1E" opacity="0.6"/>
                <rect x="14" y="98" width="68" height="4" rx="2" fill="#3C1E1E" opacity="0.15"/>
                <rect x="14" y="106" width="45" height="4" rx="2" fill="#3C1E1E" opacity="0.15"/>
                <rect x="14" y="118" width="40" height="9" rx="4.5" fill="#F7E600" opacity="0.5"/>
                <!-- 두번째 카드 -->
                <rect x="98" y="12" width="58" height="116" rx="10" fill="#F7E600" opacity="0.06" stroke="#F7E600" stroke-width="1" stroke-dasharray="3 2"/>
                <rect x="104" y="20" width="46" height="36" rx="6" fill="#FFE0B2" opacity="0.5"/>
                <rect x="104" y="62" width="32" height="5" rx="2.5" fill="#3C1E1E" opacity="0.2"/>
                <rect x="104" y="72" width="28" height="5" rx="2.5" fill="#3C1E1E" opacity="0.3"/>
              </svg>
              <!-- WIDE_ITEM_LIST -->
              <svg v-else-if="type === 'WIDE_ITEM_LIST'" viewBox="0 0 160 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="8" width="144" height="124" rx="12" fill="#F7E600" opacity="0.1" stroke="#F7E600" stroke-width="1.5"/>
                <rect x="16" y="16" width="72" height="40" rx="6" fill="#DCEDC8"/>
                <rect x="94" y="20" width="50" height="7" rx="3" fill="#3C1E1E" opacity="0.5"/>
                <rect x="94" y="32" width="40" height="5" rx="2.5" fill="#3C1E1E" opacity="0.2"/>
                <rect x="94" y="42" width="30" height="5" rx="2.5" fill="#3C1E1E" opacity="0.2"/>
                <line x1="16" y1="64" x2="144" y2="64" stroke="#3C1E1E" opacity="0.1" stroke-width="1"/>
                <rect x="16" y="72" width="20" height="20" rx="4" fill="#E8EAF6"/>
                <rect x="42" y="74" width="60" height="5" rx="2.5" fill="#3C1E1E" opacity="0.4"/>
                <rect x="42" y="84" width="40" height="4" rx="2" fill="#3C1E1E" opacity="0.15"/>
                <line x1="16" y1="100" x2="144" y2="100" stroke="#3C1E1E" opacity="0.1" stroke-width="1"/>
                <rect x="16" y="106" width="20" height="20" rx="4" fill="#FFF9C4"/>
                <rect x="42" y="108" width="55" height="5" rx="2.5" fill="#3C1E1E" opacity="0.4"/>
                <rect x="42" y="118" width="35" height="4" rx="2" fill="#3C1E1E" opacity="0.15"/>
              </svg>
              <!-- PREMIUM_VIDEO -->
              <svg v-else-if="type === 'PREMIUM_VIDEO'" viewBox="0 0 160 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="8" width="144" height="104" rx="12" fill="#F7E600" opacity="0.1" stroke="#F7E600" stroke-width="1.5"/>
                <rect x="16" y="16" width="128" height="60" rx="8" fill="#263238"/>
                <polygon points="72,34 72,58 92,46" fill="white" opacity="0.8"/>
                <rect x="20" y="84" width="90" height="7" rx="3" fill="#3C1E1E" opacity="0.5"/>
                <rect x="20" y="95" width="60" height="5" rx="2.5" fill="#3C1E1E" opacity="0.2"/>
              </svg>
            </div>
          </div>
        </div>

        <!-- ===== 섹션 2: 수신번호 ===== -->
        <div class="section">
          <div class="section-title">
            <i class="ph ph-phone"></i>
            <span>기본 정보</span>
            <em class="required">(필수)</em>
          </div>
          <div class="field">
            <label>수신번호</label>
            <input v-model="to" placeholder="01012345678" />
          </div>
        </div>

        <!-- ===== 섹션 3: 메시지 내용 ===== -->
        <div v-if="['TEXT','IMAGE','WIDE','PREMIUM_VIDEO'].includes(type)" class="section">
          <div class="section-title">
            <i class="ph ph-text-aa"></i>
            <span>메시지 내용</span>
          </div>
          <div class="field">
            <div class="field-header">
              <label>내용</label>
              <span class="char-hint">{{ textPlaceholder }}</span>
            </div>
            <textarea v-model="text" rows="4" :placeholder="'메시지 내용을 입력하세요.'"></textarea>
          </div>
        </div>

        <!-- ===== 섹션 4: 이미지 업로드 ===== -->
        <div v-if="imageSlots.length > 0" class="section">
          <div class="section-title">
            <i class="ph ph-image"></i>
            <span>이미지</span>
          </div>

          <div class="image-slots">
            <div v-for="(slot, i) in imageSlots" :key="i" class="image-slot">
              <!-- 업로드 완료 상태 -->
              <div v-if="slot.imageId" class="slot-complete">
                <div class="slot-preview" v-if="slot.preview">
                  <img :src="slot.preview" />
                </div>
                <div class="slot-info">
                  <span class="slot-label">{{ slot.label }}</span>
                  <span class="slot-badge success"><i class="ph ph-check-circle"></i> 업로드 완료</span>
                </div>
              </div>

              <!-- 파일 선택 후 미업로드 상태 -->
              <div v-else-if="slot.file" class="slot-selected">
                <div class="slot-preview" v-if="slot.preview">
                  <img :src="slot.preview" />
                </div>
                <div class="slot-info">
                  <span class="slot-label">{{ slot.label }}</span>
                  <span class="slot-badge pending">파일 선택됨</span>
                </div>
                <button class="btn-upload-single" @click="uploadImage(i)" :disabled="slot.uploading">
                  <i class="ph ph-upload-simple"></i>
                  {{ slot.uploading ? '업로드 중...' : '업로드' }}
                </button>
              </div>

              <!-- 파일 미선택 상태 (드래그앤드롭 스타일) -->
              <label v-else class="drop-zone">
                <i class="ph ph-cloud-arrow-up"></i>
                <div class="drop-text">
                  <strong>{{ slot.label }}</strong>
                  <span>클릭하여 파일 선택</span>
                </div>
                <input type="file" accept="image/*" @change="e => onFileSelect(e, i)" hidden />
              </label>
            </div>
          </div>

          <!-- 전체 업로드 버튼 -->
          <button v-if="hasUnuploaded" class="btn-upload-all" @click="uploadAll" :disabled="uploading">
            <i class="ph ph-cloud-arrow-up"></i>
            {{ uploading ? '전체 업로드 중...' : '전체 업로드' }}
          </button>
        </div>

        <!-- ===== 섹션 6: 와이드 리스트 아이템 (WIDE_ITEM_LIST) ===== -->
        <div v-if="type === 'WIDE_ITEM_LIST'" class="section">
          <div class="section-title">
            <i class="ph ph-list-bullets"></i>
            <span>아이템 리스트</span>
            <em class="required">(필수)</em>
          </div>

          <div class="field">
            <label>메인 타이틀</label>
            <input v-model="wideList.mainTitle" placeholder="메인 아이템 제목" />
          </div>

          <div class="field">
            <label>메인 설명</label>
            <input v-model="wideList.mainDesc" placeholder="메인 아이템 설명 (선택)" />
          </div>

          <div class="sub-items">
            <div v-for="(item, i) in wideList.subItems" :key="i" class="sub-item">
              <div class="sub-item-num">{{ i + 1 }}</div>
              <div class="sub-item-fields">
                <input v-model="item.title" :placeholder="'서브 아이템 ' + (i+1) + ' 제목'" />
                <input v-model="item.desc" :placeholder="'설명 (선택)'" />
              </div>
            </div>
          </div>
        </div>

        <!-- ===== 섹션 7: 캐러셀 피드 헤더 (CAROUSEL_FEED) ===== -->
        <div v-if="type === 'CAROUSEL_FEED'" class="section">
          <div class="section-title">
            <i class="ph ph-text-aa"></i>
            <span>카드 헤더</span>
          </div>
          <div class="field">
            <label>카드 헤더 텍스트</label>
            <input v-model="carouselHeader" placeholder="캐러셀 카드 상단 헤더 (선택)" />
          </div>
        </div>

      </div>

      <!-- 결과 -->
      <div v-if="resultMsg" :class="['result', resultSuccess ? 'success' : 'fail']">
        <i :class="['ph', resultSuccess ? 'ph-check-circle' : 'ph-x-circle']"></i>
        {{ resultMsg }}
      </div>

      <!-- 하단 발송 버튼 -->
      <div class="footer">
        <button class="send-btn" @click="sendBmsFree" :disabled="loading">
          <i class="ph ph-paper-plane-tilt"></i>
          {{ loading ? '발송 중...' : '테스트 발송' }}
        </button>
      </div>

    </div>
  </div>
</template>


<script>
import { ref, computed, watch } from "vue"
import axios from "axios"

const IMAGE_SLOTS = {
  TEXT: [],
  IMAGE: [{ label: '이미지', type: 'BMS_IMAGE' }],
  WIDE: [{ label: '와이드 이미지', type: 'BMS_WIDE' }],
  COMMERCE: [{ label: '상품 이미지', type: 'BMS_COMMERCE' }],
  CAROUSEL_FEED: [
    { label: '카드1 이미지', type: 'BMS_CAROUSEL_FEED_LIST' },
    { label: '카드2 이미지', type: 'BMS_CAROUSEL_FEED_LIST' },
    { label: '카드3 이미지 (선택)', type: 'BMS_CAROUSEL_FEED_LIST' },
  ],
  CAROUSEL_COMMERCE: [
    { label: '인트로 이미지 (선택)', type: 'BMS_CAROUSEL_COMMERCE_LIST' },
    { label: '상품1 이미지', type: 'BMS_CAROUSEL_COMMERCE_LIST' },
    { label: '상품2 이미지', type: 'BMS_CAROUSEL_COMMERCE_LIST' },
  ],
  WIDE_ITEM_LIST: [
    { label: '메인 이미지', type: 'BMS_WIDE_MAIN_ITEM_LIST' },
    { label: '서브1 이미지', type: 'BMS_WIDE_SUB_ITEM_LIST' },
    { label: '서브2 이미지', type: 'BMS_WIDE_SUB_ITEM_LIST' },
  ],
  PREMIUM_VIDEO: [{ label: '썸네일 이미지 (선택)', type: 'BMS_PREMIUM_VIDEO' }],
}

const TYPE_INFO = {
  TEXT:              { label: '텍스트형', desc: '일반 텍스트형 메시지를 발송합니다. 최대 1,300자까지 입력 가능합니다.' },
  IMAGE:            { label: '이미지형', desc: '이미지와 텍스트를 함께 발송합니다. 텍스트 최대 400자.' },
  WIDE:             { label: '와이드형', desc: '넓은 이미지와 짧은 텍스트를 발송합니다. 텍스트 최대 76자.' },
  COMMERCE:         { label: '커머스형', desc: '상품 이미지와 가격 정보를 포함한 커머스형 메시지입니다.' },
  CAROUSEL_FEED:    { label: '캐러셀 피드형', desc: '슬라이드 형태의 카드 메시지입니다. 이미지 최소 2장 필요.' },
  CAROUSEL_COMMERCE:{ label: '캐러셀 커머스형', desc: '슬라이드 형태의 상품 카드 메시지입니다. 이미지 최소 2장 필요.' },
  WIDE_ITEM_LIST:   { label: '와이드 리스트형', desc: '메인 이미지와 서브 항목 리스트를 포함한 메시지입니다.' },
  PREMIUM_VIDEO:    { label: '프리미엄 동영상', desc: '동영상과 텍스트를 발송합니다. 텍스트 최대 76자.' },
}

export default {
  props: {
    oth_showBmsTest: Function
  },
  setup() {
    const to = ref('')
    const type = ref('TEXT')
    const text = ref('')
    const imageSlots = ref([])
    const loading = ref(false)
    const uploading = ref(false)
    const resultMsg = ref('')
    const resultSuccess = ref(false)
    const carouselHeader = ref('')

    // 와이드 리스트 아이템
    const wideList = ref({
      mainTitle: '',
      mainDesc: '',
      subItems: [
        { title: '', desc: '' },
        { title: '', desc: '' },
      ]
    })

    const types = [
      { value: 'TEXT',              label: '텍스트',       icon: 'ph-text-aa' },
      { value: 'IMAGE',            label: '이미지',       icon: 'ph-image-square' },
      { value: 'WIDE',             label: '와이드',       icon: 'ph-columns' },
      { value: 'COMMERCE',         label: '커머스',       icon: 'ph-storefront' },
      { value: 'CAROUSEL_FEED',    label: '캐러셀 피드',  icon: 'ph-cards' },
      { value: 'CAROUSEL_COMMERCE',label: '캐러셀 커머스', icon: 'ph-shopping-cart' },
      { value: 'WIDE_ITEM_LIST',   label: '와이드 리스트', icon: 'ph-list-bullets' },
      { value: 'PREMIUM_VIDEO',    label: '프리미엄 비디오', icon: 'ph-video' },
    ]

    const currentTypeInfo = computed(() => TYPE_INFO[type.value] || TYPE_INFO.TEXT)

    const textPlaceholder = computed(() => {
      const map = {
        TEXT: '최대 1,300자',
        IMAGE: '최대 400자',
        WIDE: '최대 76자',
        PREMIUM_VIDEO: '최대 76자',
      }
      return map[type.value] || ''
    })

    const hasUnuploaded = computed(() => {
      return imageSlots.value.some(s => s.file && !s.imageId)
    })

    // 타입 변경 시 이미지 슬롯 리셋
    watch(type, (val) => {
      const slots = IMAGE_SLOTS[val] || []
      imageSlots.value = slots.map(s => ({
        ...s,
        file: null,
        preview: null,
        imageId: '',
        uploading: false
      }))
      resultMsg.value = ''
      // 추가 필드 리셋
      wideList.value = { mainTitle: '', mainDesc: '', subItems: [{ title: '', desc: '' }, { title: '', desc: '' }] }
      carouselHeader.value = ''
    }, { immediate: true })

    function onFileSelect(e, index) {
      const file = e.target.files[0]
      if (!file) return
      imageSlots.value[index].file = file
      imageSlots.value[index].imageId = ''
      const reader = new FileReader()
      reader.onload = ev => { imageSlots.value[index].preview = ev.target.result }
      reader.readAsDataURL(file)
    }

    async function uploadImage(index) {
      const slot = imageSlots.value[index]
      if (!slot.file) return
      slot.uploading = true
      try {
        const formData = new FormData()
        formData.append('image', slot.file)
        formData.append('imageType', slot.type)
        const { data } = await axios.post('/api/test/bms-upload', formData)
        slot.imageId = data.imageId
      } catch (e) {
        alert(`${slot.label} 업로드 실패: ${e.response?.data?.message || e.message}`)
      } finally {
        slot.uploading = false
      }
    }

    async function uploadAll() {
      uploading.value = true
      for (let i = 0; i < imageSlots.value.length; i++) {
        const slot = imageSlots.value[i]
        if (slot.file && !slot.imageId) {
          await uploadImage(i)
        }
      }
      uploading.value = false
    }

    async function sendBmsFree() {
      if (!to.value) return alert('수신번호를 입력하세요')

      loading.value = true
      resultMsg.value = ''

      try {
        const body = {
          to: to.value.replace(/-/g, ''),
          type: type.value,
          text: text.value || undefined
        }

        if (['IMAGE', 'WIDE', 'COMMERCE'].includes(type.value)) {
          const id = imageSlots.value[0]?.imageId
          if (!id) { alert('이미지를 먼저 업로드하세요'); loading.value = false; return }
          body.imageId = id
        }

        if (['CAROUSEL_FEED', 'CAROUSEL_COMMERCE', 'WIDE_ITEM_LIST'].includes(type.value)) {
          const ids = imageSlots.value.filter(s => s.imageId).map(s => s.imageId)
          if (ids.length < 2) { alert('이미지를 최소 2개 이상 업로드하세요'); loading.value = false; return }
          body.imageIds = ids
        }

        if (type.value === 'PREMIUM_VIDEO') {
          const id = imageSlots.value[0]?.imageId
          if (id) body.imageId = id
        }

        // 와이드 리스트 아이템
        if (type.value === 'WIDE_ITEM_LIST') {
          const w = wideList.value
          if (!w.mainTitle) { alert('메인 타이틀을 입력하세요'); loading.value = false; return }
          body.wideList = {
            mainTitle: w.mainTitle,
            mainDesc: w.mainDesc || undefined,
            subItems: w.subItems.filter(s => s.title).map(s => ({
              title: s.title,
              desc: s.desc || undefined
            }))
          }
        }

        // 캐러셀 피드 헤더
        if (type.value === 'CAROUSEL_FEED' && carouselHeader.value) {
          body.carouselHeader = carouselHeader.value
        }

        const { data } = await axios.post('/api/test/bms-free', body)

        if (data.failedMessageList?.length > 0) {
          resultSuccess.value = false
          resultMsg.value = '발송 실패: ' + (data.failedMessageList[0]?.statusMessage || '알 수 없는 오류')
        } else {
          resultSuccess.value = true
          resultMsg.value = `${type.value} 발송 성공! (groupId: ${data.groupInfo?.groupId || '-'})`
        }
      } catch (e) {
        resultSuccess.value = false
        const detail = e.response?.data
        const failMsg = detail?.failedMessageList?.[0]?.statusMessage || detail?.message || e.message
        resultMsg.value = failMsg
      } finally {
        loading.value = false
      }
    }

    return {
      to, type, text, types, textPlaceholder, currentTypeInfo,
      imageSlots, hasUnuploaded,
      wideList, carouselHeader,
      loading, uploading, resultMsg, resultSuccess,
      onFileSelect, uploadImage, uploadAll, sendBmsFree
    }
  }
}
</script>


<style scoped>
.dialog {
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  backdrop-filter: blur(2px);
}

.dialog > .cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog > .paper {
  width: 90%;
  max-width:600px;
  height: 88%;
  background: var(--color-background);
  border:1px solid var(--color-background-light);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap:12px;
  display:flex;
  flex-direction: column;
}

/* 헤더 */
.paper > .header {
  width:100%;
  height:var(--font-size-3xl);
  display:flex;
  justify-content: space-between;
  align-items:center;
  flex-shrink: 0;
}

.paper > .header > h2 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin:0;
  padding:0;
}

.paper > .header > span {
  width:var(--font-size-3xl);
  height:var(--font-size-3xl);
  display:flex;
  justify-content: center;
  align-items: center;
  cursor:pointer;
}

.paper > .header > span > i {
  font-size: var(--font-size-xl);
  color: var(--color-text-primary);
}

/* 스크롤 영역 */
.scroll-area {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-right: 4px;
}

/* ===== 섹션 ===== */
.section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid var(--color-background-light);
  border-radius: 12px;
  padding: 14px;
  background: var(--color-background);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.section-title > i {
  font-size: var(--font-size-lg);
  color: var(--color-brand);
}

.section-title > .required {
  font-size: var(--font-size-xs);
  color: #ef4444;
  font-weight: var(--font-weight-regular);
  font-style: normal;
}

/* ===== 타입 그리드 ===== */
.type-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
}

.type-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 4px;
  border: 1px solid var(--color-background-light);
  border-radius: 10px;
  background: var(--color-surface);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.15s;
  font-size: var(--font-size-xs);
  text-align: center;
  line-height: 1.2;
}

.type-card > i {
  font-size: var(--font-size-xl);
}

.type-card:hover {
  border-color: var(--color-brand);
  color: var(--color-brand);
}

.type-card.active {
  background: var(--color-brand);
  color: #fff;
  border-color: var(--color-brand);
  font-weight: var(--font-weight-semibold);
}

/* ===== Info Box ===== */
.type-detail {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

.type-detail .info-box {
  flex: 1;
  min-width: 0;
}

.preview-mockup {
  flex-shrink: 0;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafbfc;
  border: 1px solid var(--color-background-light);
  border-radius: 10px;
  padding: 8px;
}

.preview-mockup svg {
  width: 100%;
  height: auto;
  display: block;
}

.info-box {
  display: flex;
  gap: 8px;
  padding: 10px 12px;
  background: rgba(59, 130, 246, 0.06);
  border: 1px solid rgba(59, 130, 246, 0.15);
  border-radius: 8px;
  align-items: flex-start;
}

.info-box > i {
  font-size: var(--font-size-lg);
  color: #3b82f6;
  flex-shrink: 0;
  margin-top: 1px;
}

.info-box strong {
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  display: block;
  margin-bottom: 2px;
}

.info-box p {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.4;
}

/* ===== 필드 ===== */
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.field > label,
.field-header > label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
}

.char-hint {
  font-size: var(--font-size-xs);
  color: var(--color-text-tertiary, #999);
}

.field input,
.field textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--color-background-light);
  border-radius: 8px;
  font-size: var(--font-size-sm);
  background: var(--color-surface);
  color: var(--color-text-primary);
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.15s;
}

.field input:focus,
.field textarea:focus {
  border-color: var(--color-brand);
}

.field textarea {
  resize: none;
}

/* ===== 이미지 슬롯 ===== */
.image-slots {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.image-slot {
  border: 1px solid var(--color-background-light);
  border-radius: 10px;
  overflow: hidden;
  background: var(--color-surface);
}

/* 드래그앤드롭 존 */
.drop-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 20px 12px;
  cursor: pointer;
  transition: all 0.15s;
  border: 2px dashed var(--color-background-light);
  border-radius: 10px;
  margin: -1px;
}

.drop-zone:hover {
  border-color: var(--color-brand);
  background: rgba(59, 130, 246, 0.03);
}

.drop-zone > i {
  font-size: 28px;
  color: var(--color-text-tertiary, #999);
}

.drop-zone:hover > i {
  color: var(--color-brand);
}

.drop-text {
  text-align: center;
  line-height: 1.3;
}

.drop-text strong {
  display: block;
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
}

.drop-text span {
  font-size: var(--font-size-xs);
  color: var(--color-text-tertiary, #999);
}

/* 파일 선택됨 / 업로드 완료 */
.slot-complete,
.slot-selected {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
}

.slot-preview {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.slot-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.slot-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.slot-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.slot-badge {
  font-size: var(--font-size-xs);
  display: inline-flex;
  align-items: center;
  gap: 3px;
  width: fit-content;
}

.slot-badge.success {
  color: #16a34a;
}

.slot-badge.pending {
  color: var(--color-text-tertiary, #999);
}

.btn-upload-single {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: none;
  border-radius: 8px;
  font-size: var(--font-size-xs);
  background: var(--color-brand);
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.btn-upload-single:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-upload-all {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 10px;
  border: 1px dashed var(--color-brand);
  border-radius: 8px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  background: transparent;
  color: var(--color-brand);
  cursor: pointer;
}

.btn-upload-all:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ===== Sub Items (와이드 리스트) ===== */
.sub-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sub-item {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.sub-item-num {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--color-brand);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  flex-shrink: 0;
  margin-top: 8px;
}

.sub-item-fields {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sub-item-fields input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--color-background-light);
  border-radius: 8px;
  font-size: var(--font-size-sm);
  background: var(--color-surface);
  color: var(--color-text-primary);
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.15s;
}

.sub-item-fields input:focus {
  border-color: var(--color-brand);
}

/* ===== 결과 ===== */
.result {
  flex-shrink: 0;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: var(--font-size-sm);
  word-break: break-all;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.result > i {
  font-size: var(--font-size-lg);
  flex-shrink: 0;
  margin-top: 1px;
}

.result.success {
  background: #f0fdf4;
  color: #16a34a;
  border: 1px solid #bbf7d0;
}

.result.fail {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

/* ===== 하단 버튼 ===== */
.footer {
  flex-shrink: 0;
}

.send-btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 10px;
  background: var(--color-brand);
  color: #fff;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: opacity 0.15s;
}

.send-btn:hover {
  opacity: 0.9;
}

.send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>